import { EndpointBuilder } from 'services/api/baseApi';
import { MobileSettings } from 'types/entities/MobileSettings';
export function getMobileSettingsEndpoints(builder: EndpointBuilder) {
  return {
    getMobileSettings: builder.query<MobileSettings, void>({
      query: () => ({
        url: `/api/mobile/settings`,
        method: 'GET',
      }),
    }),
  };
}
